import { SelectOption, SelectOptionGroup } from "@amzn/meridian";
import React from "react";
import { INADEQUATE_INFORMATION, OTHER } from "src/constants";

export const getInadequateSelection = () => {
  return (
    <SelectOptionGroup label={"Answer not exist in the description"}>
      <SelectOption label={INADEQUATE_INFORMATION} value={INADEQUATE_INFORMATION} />
    </SelectOptionGroup>
  );
};

export const otherSelection = () => {
  return (
    <SelectOptionGroup label={"Not available in option list"}>
      <SelectOption label={OTHER} value={OTHER} />
    </SelectOptionGroup>
  );
};
